/** `/api/v2/auth` – Anmeldung, Abmeldung, aktuelle Sitzung. */
import { http } from './http'
import type { ChangePasswordRequest, LoginRequest, MeResponse, User } from './types'

/**
 * Meldet an. `skipAuthRedirect`, weil ein 401 hier eine falsche
 * Eingabe ist – kein Sitzungsablauf.
 */
export function login(payload: LoginRequest): Promise<User> {
  return http.post<User>('/auth/login', payload, { skipAuthRedirect: true })
}

export function logout(): Promise<void> {
  return http.post<void>('/auth/logout')
}

/**
 * Aktuelle Sitzung. `skipAuthRedirect`, weil das Ergebnis „nicht angemeldet“
 * beim Start ein normaler Zustand ist (der Guard leitet dann selbst um).
 */
export function me(): Promise<MeResponse> {
  return http.get<MeResponse>('/auth/me', { skipAuthRedirect: true })
}

export function changePassword(payload: ChangePasswordRequest): Promise<void> {
  return http.post<void>('/auth/change-password', payload)
}

export const authApi = { login, logout, me, changePassword }
